import React from "react";
import { StarHalfIcon, StarIcon } from "lucide-react";
type CtaButtonProps = {
  label?: string;
  href?: string;
  caption?: string;
  align?: "center" | "start";
  captionTone?: "muted" | "light";
  size?: "md" | "lg";
  rating?: {
    score: string;
    text: string;
  };
};
export function CtaButton({
  label = "Get Woodworking Ready™ now",
  href = "https://woodworking-ready.impultienda.ar/checkout",
  caption,
  align = "center",
  captionTone = "muted",
  size = "md",
  rating
}: CtaButtonProps) {
  const large = size === "lg";
  return <div className={`flex flex-col gap-2 ${align === "center" ? "items-center" : "items-start"} ${large ? "w-full" : ""}`} data-id="element-46" data-mp="ll7aji3ocrkc">
      {rating && <div className="flex flex-col items-center gap-1.5" data-id="element-47" data-mp="vaqtsovaunfq">
          <div className="flex gap-1" aria-label={`Rated ${rating.score} out of 5`} data-id="element-48" data-mp="vddb3g7zshb5">
            {[0, 1, 2, 3].map(i => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-49" data-mp="159q389nw2n3s" />)}
            <StarHalfIcon className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-50" data-mp="35xxruolc2ls8" />
          </div>
          <p className="font-heading text-sm text-ink md:text-base" data-id="element-51" data-mp="39zsqflbvql2b">
            {rating.score} ({rating.text})
          </p>
        </div>}
      <a href={href} className={`inline-flex items-center justify-center whitespace-nowrap bg-brand font-heading font-bold uppercase tracking-wide text-white shadow-md transition-[background-color,transform] duration-150 ease-out hover:bg-brand-dark active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 ${large ? "mt-2 w-full max-w-3xl rounded-xl px-6 py-5 text-lg md:text-2xl" : "rounded-md px-8 py-3.5 text-sm"}`} data-id="element-52" data-mp="3f071lc8s2b4k">
        {label}
      </a>
      {caption && <p className={`${large ? "font-heading text-sm md:text-base" : "text-xs"} ${captionTone === "light" ? "text-white/70" : large ? "text-ink" : "text-ink-muted"}`} data-id="element-53" data-mp="bioux84qra5q">
          {caption}
        </p>}
    </div>;
}